import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .controller('RiskSelfAssessmentReviewByAssessorSummaryController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'govProcess', 'risksToReview', 'criterias', 'assessmentQuestions', 'exportService'];

    function Controller($scope, $state, $stateParams, govProcess, risksToReview, criterias, assessmentQuestions, exportService) {
        var overallRatings = _.filter(criterias, {RiskLookupAssessmentTypeName: 'Overall'});
        var naRating       = {Color: 'default', Name: 'N/A'};

        if (!_.isArray(risksToReview)) {
            return;
        }

        $scope.govProcess          = govProcess;
        $scope.risksToReview       = risksToReview;
        $scope.assessmentQuestions = assessmentQuestions;
        $scope.view                = {
            reviewCompleted: false
        };

        // Assessor
        $scope.getAssessorId = function () {
            return risksToReview[0].Risk.AssessorID;
        };

        var firstRiskToReviewIdx = getFirstRiskToReviewIndex();
        if (firstRiskToReviewIdx === -1) {
            $scope.view.reviewCompleted = true;
        }

        // Continue review
        $scope.continueReview = function () {
            if (firstRiskToReviewIdx > -1) {
                $state.go('riskSelfAssessmentReviewByAssessor.risk', {RiskID: risksToReview[firstRiskToReviewIdx].Risk.RiskID});
            }
        };
        // Poll export
        $scope.pollExport = function () {
          exportService.pollExport($scope.urlToExportSummaryReport(), {});
        };

        // Export Summary Report
        $scope.urlToExportSummaryReport = function () {
            return environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment/Assessor@' + $stateParams.AssessorID + '/Review/SummaryExportToReport';
        };

        // Get Computed overall Rating
        $scope.getComputedOverallRating = function (riskToReview) {
            if (!riskToReview.Assessment || !riskToReview.Assessment.InitialComputedOverallCode) {
                return naRating;
            }

            return _.find(overallRatings, {Code: riskToReview.Assessment.InitialComputedOverallCode});
        };

        // Get Overall Rating
        $scope.getOverallRating = function (riskToReview) {
            if (!riskToReview.Assessment || !riskToReview.Assessment.InitialOverallCode) {
                return naRating;
            }

            return _.find(overallRatings, {Code: riskToReview.Assessment.InitialOverallCode});
        };

        $scope.goToPreliminaryQuestions = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.preliminaryQuestions');
        };

        // Go to Review Risk Assessment
        $scope.goToReviewRiskAssessment = function (risk) {
            $state.go('riskSelfAssessmentReviewByAssessor.risk', {RiskID: risk.RiskID});
        };

        $scope.goToFinalQuestions = function () {
            $state.go('riskSelfAssessmentReviewByAssessor.finalQuestions');
        };

        $scope.goToAssessors = function () {
            $state.go('riskSelfAssessmentList');
        };

        // Helpers
        function getFirstRiskToReviewIndex() {
            var firstRiskToReviewIdx = _.findIndex(risksToReview, function (risk) {
                return !risk.Assessment || !risk.Assessment.HasFinalAssessorReviewed;
            });

            return firstRiskToReviewIdx;
        }
    }
})();
